import React from "react";
import styled from "styled-components";
import breakpoint from "../../../../utils/breakpoint";
import space from "../../../../utils/space";
import TextAtm from "../../../atoms/TextAtm";
var Title = styled(TextAtm).withConfig({
  componentId: "sc-1rplbyt-0"
})(["min-height:", ";font-feature-settings:\"clig\" off,\"liga\" off;margin-bottom:", ";white-space:pre-line;", "{margin-bottom:", ";}"], space(8), space(1.5), breakpoint("medium"), space(3));
var CategoryTitle = function CategoryTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Title, {
    typography: "large3",
    color: "white"
  }, children);
};
export default CategoryTitle;